import { toast } from "sonner";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";
const csrf = () => (document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/) || [])[1] || "";

export const isOfflineError = (e) => !navigator.onLine || (!e?.response && (e?.code === "ERR_NETWORK" || e?.message === "Network Error"));

const sha256 = async (text) => {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
};

/** Deterministic outbox idempotency key: sha256(sender_id|recipient_id|content_hash|created_at_ms). */
export async function outboxIdempotencyKey(senderId, recipientId, body, createdAtMs) {
  if (!crypto?.subtle) return null;
  return sha256(`${senderId || ""}|${recipientId || ""}|${await sha256(JSON.stringify(body))}|${createdAtMs}`);
}

/** Hand an unsent write to the service worker's IndexedDB outbox; it retries via Background Sync when back online. */
export async function queueOffline(kind, path, body, extra = {}) {
  const reg = await navigator.serviceWorker?.ready;
  if (!reg?.active) return false;
  const createdAt = Date.now();
  const { sender_id, recipient_id, ...rest } = extra;
  const idempotency_key = await outboxIdempotencyKey(sender_id, recipient_id || extra.room_id || kind, body, createdAt);
  const item = { id: `${kind}-${createdAt}-${Math.random().toString(36).slice(2, 8)}`, kind, url: API + path, body, csrf: decodeURIComponent(csrf()), idempotency_key, created_at_ms: createdAt, ...rest };
  reg.active.postMessage({ type: "outbox-add", item });
  return item.id;
}

let installed = false;
export function installOutboxListener() {
  if (installed || !("serviceWorker" in navigator)) return;
  installed = true;
  navigator.serviceWorker.addEventListener("message", (ev) => {
    const d = ev.data || {};
    const what = d.kind === "howl" ? "howl" : d.kind === "dm" ? "message" : "den message";
    if (d.type === "outbox-queued") toast.message(`You're offline — your ${what} is saved and will send when you reconnect.`);
    if (d.type === "outbox-sent") { toast.success(d.kind === "howl" ? "Your offline howl was published." : `Your offline ${what} was sent.`); window.dispatchEvent(new CustomEvent("outbox-sent", { detail: d })); }
    if (d.type === "outbox-failed") toast.error(`Couldn't send your saved ${what} after 3 tries — it's kept safe.`, {
      duration: 15000, action: { label: "Retry", onClick: () => navigator.serviceWorker.ready.then((r) => r.active?.postMessage({ type: "outbox-retry", id: d.id })) } });
  });
  window.addEventListener("online", () => navigator.serviceWorker.ready.then((r) => r.active?.postMessage({ type: "outbox-flush" })));
}
